import { ISelectOption } from '@busybusy/webapp-react-ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IGroup from 'types/Group';
import { ALL_GROUPS, NO_GROUP } from 'utils/constants/stringConstants';

export default function useGroupSelectOptions<T extends IGroup>(groupOptionConfiguration: {
  groups: T[];
  includeNoneOption: boolean;
  includeAllOption: boolean;
  allLabel?: string;
}) {
  const { groups, includeAllOption, includeNoneOption, allLabel } = groupOptionConfiguration;

  const [t] = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>(getOptions());

  useEffect(() => {
    if (groups) {
      setOptions(getOptions());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groups]);

  function getOptions() {
    const opts = [];

    if (includeAllOption && allLabel) {
      opts.push({ label: allLabel, value: ALL_GROUPS });
    }

    opts.push(...groups.map((group) => ({ value: group.id, label: group.groupName })));

    if (includeNoneOption) {
      opts.push({ label: t('No Group'), value: NO_GROUP });
    }

    return opts;
  }

  return options;
}
